export const shouldActivatePendingCloudSession = <T>(
  matchActive: boolean,
  pending: T | null,
  activating: T | null,
): pending is T => !matchActive && pending !== null && activating !== pending;
